import React from 'react';
import logo from '../../images/logo/webb gra.png';
import Image from 'react-bootstrap/Image';
import styles from './styles.module.scss';

export default function HomePage() {
    return(
        <div className={`${styles.container} home-container`}>
            <Image fluid alt="logo" src={logo} />
        </div>
    )
}